import React, { useEffect, useRef, useState } from 'react'
import { SBack, SListTabs,SGeneralForms } from 'shj-components'
import { Modal,Spin,Card } from 'antd'
import FullPlan from '../components/fullPlan'
import InstallmentPlan from '../components/InstallmentPlan'
import {getReceiptRulesPlanMain} from '@/services/fmsConfig'
import { useParams } from 'react-router-dom'
export default function () {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [loading, setLoading] = useState(false)
  const [activeKey, setActiveKey] = useState('1')
  const [detailsInfo, setDetailsInfo] = useState(null)
  const { id } = useParams()
  // 收款详情
  const infoConfig = [
    {
      title: '',
      formItem: [
        {
          name: 'name',
          label: '收款计划名称',
          spanCol: 8,
        },
        {
          name: 'remarks',
          label: '描述',
          spanCol: 8,
        },
        {
          name: 'enabledName',
          label: '状态',
          spanCol: 8,
        },
        {
          name: 'isDefault',
          label: '是否默认',
          spanCol: 8,
          type: 'switch',
          checkedChildren: "是",
          unCheckedChildren: "否",
        },
      ],
    },
  ]
  useEffect(() => {
    initFn()
  }, [id])
  const initFn = async () => {
    setLoading(true)
    getReceiptRulesPlanMain(id)
      .then(res => {
        setDetailsInfo(res)
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
      })
  }
  const handleTabChange = (key: string) => {
    if (hasUnsavedChanges) {
      Modal.confirm({
        title: '提示',
        content: '更改未保存，是否确认切换？',
        okText: '切换',
        cancelText: '取消',
        onOk: () => {
          setHasUnsavedChanges(false)
          setActiveKey(key)
        },
        onCancel: () => {
          setActiveKey(key==='2'?'1':'2')
        }
      })
      setActiveKey(key==='2'?'1':'2')
      return false
    }
    setActiveKey(key)
    return true
  }

  const handleDataChange = (hasChanges = true) => {
    setHasUnsavedChanges(hasChanges);
  }

  const items = [
    {
      key: '1',
      value: '1',
      label: '全额计划',
      children: <FullPlan onDataChange={handleDataChange} />,
    },
    {
      key: '2',
      value: '2',
      label: '分期计划',
      children: <InstallmentPlan onDataChange={handleDataChange} />,
    },
  ]
  
  return (
    <SBack title={`收款计划详情`} level={2}>
      <div style={{ backgroundColor: '#fff', padding: '15px', minWidth: '800px' }}>
      <Spin spinning={loading}>
            <Card size="small">
              <SGeneralForms
                isDetail={true}
                configs={infoConfig}
                detailsData={detailsInfo || undefined}
              />
            </Card>
          </Spin>
        <SListTabs 
          auth={''} 
          items={items}
          activeKey={activeKey}
          destroyInactiveTabPane={true}
          onChange={handleTabChange}
        />
      </div>
    </SBack>
  )
}
